<template>
  <div class="item" v-if="item" @click="goDetail(item)">
    <h3 class="item-title">
      <p v-html="filterTitle" :title="item.name || item.title"> </p>
      <span class="prize" v-if="item.award">{{ item.award }}</span>
      <span class="prize" v-if="item.searchtype == 1">{{ item.btype == 2 ? '品牌' : '专题' }}</span>
    </h3>
    <!-- 节目 -->
    <div class="item-sub" v-if="item.searchtype == 3">
      <span v-if="item.type_tag_name">{{ item.type_tag_name | formatShowFirst }}</span>
      <span v-if="item.show_time">{{ item.show_time | formatStandardDate }}</span>
      <span v-if="item.activity_name">{{ item.activity_name }}</span>
    </div>
    <!-- 人才 -->
    <div class="item-sub" v-else-if="item.searchtype == 5">
      <span v-if="item.type_tag_name">{{ item.type_tag_name | formatShowFirst }}</span>
      <span v-if="item.works">{{ item.works }}</span>
    </div>

    <!-- 专题 founder,founder_time，ctiy-->
    <div class="item-sub" v-else-if="item.searchtype == 1">
      <span v-if="item.founder">主办单位：{{ item.founder | formatStandardSep }}</span>
      <span v-if="item.founder_time">{{ item.founder_time | formatStandardDate }}</span>
      <span v-if="item.city">{{ item.city }}</span>
    </div>

    <!-- 活动 organizer,holding_time,city-->
    <div class="item-sub" v-else-if="item.searchtype == 2">
      <span v-if="item.holding_time">{{ item.holding_time | formatStandardDate }}</span>
      <span v-if="item.organizer">主办单位：{{ item.organizer | formatStandardSep }}</span>
    </div>
    <!-- 海报 -->
    <div class="item-sub" v-else-if="item.searchtype == 8">
      <span v-if="item.type_name">{{ item.type_name }}</span>
      <span v-if="item.poster_time">{{ item.poster_time | formatStandardDate }}</span>
      <span v-if="item.organizer">{{ item.organizer }}</span>
    </div>
    <!-- 展品, 文学 -->
    <div class="item-sub" v-else>
      <span v-if="item.type_name">{{ item.type_name }}</span>
      <span v-if="item.author">{{ item.author }}</span>
      <span v-if="item.show_time">{{ item.show_time | formatStandardDate }}</span>
      <span v-if="item.produce_time && !item.show_time">{{ item.produce_time | formatStandardDate }}</span>
    </div>

  </div>
</template>

<script>
import colums from '@/colums/colums.js'
export default {
  name: 'searchItem',
  props: {
    item: Object,
    keyword: String,
  },
  data() {
    return {
      jmkcate: colums.jmkcate,
      exhibitCate: colums.exhibitCate,
      literatureCate: colums.literatureCate
    }
  },
  computed: {
    filterTitle() {
      const name = this.item.name || this.item.title
      return this.$utils.lightKeyword(name, this.keyword)
    },
    path() {
      const item = this.item || {}
      const searchtype = item.searchtype
      const searchTypeObj = {
        1: 'thematic',
        2: 'activity',
        3: 'program',
        4: 'news',
        5: 'artist',
        6: 'literature',
        7: 'exhibit',
        8: 'poster'
      }

      let path = '';
      const category = item.category || item.type_id
      // console.log('searchtype: ', searchtype)
      // const hash = this.$utils.hashNum(item.access || item.no_access || 0)
      const hash = this.$utils.hashNum(0);

      if (searchtype == 3) {
        path = 'program'
      } else if (searchtype == 6) {
        path = category == 1 ? '/book' : '/literature'
      } else {
        path = searchTypeObj[searchtype]
      }
      path = `${path}/${item.id}`

      // 节目库展品库文学库
      if (searchtype == 3 || searchtype == 6 || searchtype == 7) {
        path += `/${hash}`
      }

      return path
    }
  },
  mounted() {
    // console.log('path: ', this.path)
  },
  methods: {
    goDetail() {
      const path = this.path

      try {
        let routeLink = this.$router.resolve({
          path: path
        })
        window.open(routeLink.href, "_blank")
      } catch (error) {
        this.$router.push({
          path: path
        })
      }
    }
  },
}
</script>
